/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./total-footer.vue?vue&type=template&id=26cb122a&scoped=true&"
import script from "./total-footer.vue?vue&type=script&lang=ts&"
export * from "./total-footer.vue?vue&type=script&lang=ts&"
import style0 from "./total-footer.vue?vue&type=style&index=0&id=26cb122a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26cb122a",
  null
  
)

export default component.exports